import { TranslationCatalog } from './translations.types';

export const AUTH_RECOVER_TRANSLATIONS: TranslationCatalog = {
  es: {
    'recover.title': '¡Recupera tu contraseña!',
    'recover.subtitle': 'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
    'recover.field.email': 'Correo electrónico',
    'recover.cta': 'Enviar enlace de recuperación',
    'recover.ctaLoading': 'Enviando enlace...',
    'recover.backToLogin': 'Volver al inicio de sesión',
    'recover.altLead': '¿Quieres ingresar con otra cuenta?',
    'recover.altLink': 'Inicia sesión',
    'recover.error.invalidForm': 'Ingresa un correo electrónico válido.',
    'recover.error.serverError': 'No pudimos procesar tu solicitud. Intenta nuevamente.',
    'recover.error.noConnection': 'No hay conexión con el servidor. Verifica tu red.',
    'recover.error.emailRequired': 'Ingresa tu correo electrónico.',
    'recover.error.emailInvalid': 'Ingresa un correo electrónico válido.',
    'recover.error.emailMax': 'Este campo admite máximo 254 caracteres.',
    'recover.success.title': 'Revisa tu correo',
    'recover.success.body': 'Si encontramos una cuenta asociada, te enviaremos un enlace para restablecer tu contraseña.',
    'recover.invalidLink.title': 'El enlace ya no es válido',
    'recover.invalidLink.body': 'Solicita un nuevo enlace de recuperación para continuar.',
    'recover.logoAria': 'WeMatch',
  },
  en: {
    'recover.title': 'Recover your password!',
    'recover.subtitle': 'Enter your email address and we will send you a link to reset your password.',
    'recover.field.email': 'Email',
    'recover.cta': 'Send recovery link',
    'recover.ctaLoading': 'Sending link...',
    'recover.backToLogin': 'Back to log in',
    'recover.altLead': 'Want to sign in with another account?',
    'recover.altLink': 'Log in',
    'recover.error.invalidForm': 'Enter a valid email address.',
    'recover.error.serverError': 'We could not process your request. Please try again.',
    'recover.error.noConnection': 'There is no connection to the server. Check your network.',
    'recover.error.emailRequired': 'Enter your email.',
    'recover.error.emailInvalid': 'Enter a valid email address.',
    'recover.error.emailMax': 'This field supports up to 254 characters.',
    'recover.success.title': 'Check your inbox',
    'recover.success.body': 'If we find an associated account, we will send you a link to reset your password.',
    'recover.invalidLink.title': 'This link is no longer valid',
    'recover.invalidLink.body': 'Request a new recovery link to continue.',
    'recover.logoAria': 'WeMatch',
  },
};
